/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Why_AccountInputs */

const en_us2_profile_why_account = /** @type {(inputs: Profile_Why_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your data is yours: export it whenever you like, or close your account.`)
};

const pt_br2_profile_why_account = /** @type {(inputs: Profile_Why_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus dados são seus: exporte quando quiser ou encerre a conta.`)
};

const es_419_profile_why_account = /** @type {(inputs: Profile_Why_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus datos son tuyos: expórtalos cuando quieras o cierra tu cuenta.`)
};

const pt_pt2_profile_why_account = /** @type {(inputs: Profile_Why_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os teus dados são teus: exporta-os quando quiseres ou encerra a conta.`)
};

const fr_fr2_profile_why_account = /** @type {(inputs: Profile_Why_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes données t'appartiennent : exporte-les quand tu veux, ou ferme ton compte.`)
};

const de_de2_profile_why_account = /** @type {(inputs: Profile_Why_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Daten gehören dir: Exportiere sie, wann du willst, oder schließ dein Konto.`)
};

const it_it2_profile_why_account = /** @type {(inputs: Profile_Why_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi dati sono tuoi: esportali quando vuoi o chiudi l'account.`)
};

/**
* | output |
* | --- |
* | "Your data is yours: export it whenever you like, or close your account." |
*
* @param {Profile_Why_AccountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_why_account = /** @type {((inputs?: Profile_Why_AccountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Why_AccountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_why_account(inputs)
	if (locale === "es-419") return es_419_profile_why_account(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_why_account(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_why_account(inputs)
	if (locale === "de-DE") return de_de2_profile_why_account(inputs)
	if (locale === "it-IT") return it_it2_profile_why_account(inputs)
	return en_us2_profile_why_account(inputs)
});
export { profile_why_account as "profile.why_account" }